import { DateLabelComponent } from '@/app/components/shared/date-label/date-label.component';
import { NoResultComponent } from '@/app/components/shared/no-result/no-result.component';
import { SkeletonMatchesListComponent } from '@/app/components/shared/skeleton';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  ElementRef,
  inject,
  signal,
  viewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { isToday } from 'date-fns';
import { CompetitionByTeamRowComponent } from '../../components';
import { TeamMatchesPastService } from '../../services';

@Component({
  selector: 'app-results',
  standalone: true,
  imports: [
    NoResultComponent,
    SkeletonMatchesListComponent,
    TranslateModule,
    DateLabelComponent,
    CompetitionByTeamRowComponent,
  ],
  templateUrl: './results.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultsComponent {
  private teamMatchesPastService = inject(TeamMatchesPastService);
  private observer!: IntersectionObserver;
  private route = inject(ActivatedRoute);

  teamId = signal<string>('');

  fetchComputed = computed(() => ({
    isLoading: this.teamMatchesPastService.isLoadingTeamsMatchPastFavorites(),
    isError: this.teamMatchesPastService.isErrorTeamsMatchPastFavorites(),
  }));
  teamMatchesPast = computed(() =>
    this.teamMatchesPastService.teamsMatchPast()
  );

  scoreContainerRef = viewChild<ElementRef<HTMLDivElement>>(
    'soccerMatchesContainer'
  );
  scrollTriggerRef = viewChild<ElementRef<HTMLDivElement>>('scrollTrigger');

  ngAfterViewInit() {
    // this.performanceService.activate();

    const refItem = this.scrollTriggerRef()?.nativeElement;

    if (!refItem) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (
            entry.isIntersecting &&
            this.teamMatchesPastService.isMoreMatches() &&
            this.teamMatchesPastService.teamsMatchPast() !== null &&
            this.teamMatchesPastService.paginationMatches() >= 1
          ) {
            this.teamMatchesPastService.getTeamMatchesPast(
              this.teamId(),
              this.teamMatchesPastService.paginationMatches() + 1
            );
          }
        });
      },
      {
        root: null, // null = viewport
        rootMargin: '200px', // Se activará 200px antes de que el elemento sea visible
        threshold: 0.01,
      }
    );

    this.observer.observe(refItem);

    if (!this.teamMatchesPastService.isLoadingTeamsMatchPastFavorites()) {
      this.teamMatchesPastService.getTeamMatchesPast(this.teamId());
    }

    // 👉 Primer fetch con skeleton
    if (!this.teamMatchesPastService.isLoadingTeamsMatchPastFavorites()) {
      this.teamMatchesPastService.getTeamMatchesPast(this.teamId());
    }
  }

  isNextMatches(date: Date) {
    return !isToday(date);
  }

  constructor() {
    const teamId = this.route.snapshot.paramMap.get('teamId');
    if (teamId) {
      this.teamId.set(teamId);
    }
  }

  ngOnDestroy() {
    this.teamMatchesPastService.teamsMatchPast.set(null);
    this.teamMatchesPastService.teamsMatchPagination.set(null);
  }
}
